import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";

const API_BASE = process.env.REACT_APP_API_BASE;

const OllamaStatusBadge = () => {
  const [status, setStatus] = useState("loading");
  const fetchStatus = async () => {
    try {
      const res = await fetch(`${API_BASE}/ollama-status/`);
      const data = await res.json();
      setStatus(data.status);
    } catch (error) {
      console.error("Ollama status error:", error);
      setStatus("error");
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  const getBadgeVariant = () => {
    switch (status) {
      case "online":
        return "success";
      case "unreachable":
      case "error":
        return "danger";
      case "loading":
        return "secondary";
      default:
        return "warning";
    }
  };

  const getLabel = () => {
    switch (status) {
      case "online":
        return "🟢 Ollama: Online";
      case "unreachable":
        return "🔴 Ollama: Offline";
      case "error":
        return "⚠️ Ollama: Error";
      case "loading":
        return "⏳ Checking Ollama...";
      default:
        return "⚠️ Unknown";
    }
  };

  return (
    <div className="mb-3 d-flex align-items-center gap-2">
      <Badge bg={getBadgeVariant()}>{getLabel()}</Badge>
      <button onClick={fetchStatus} className="btn btn-sm btn-outline-primary">
        Refresh
      </button>
    </div>
  );
};

export default OllamaStatusBadge;
